import { Component, OnInit, forwardRef, Input, OnChanges } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { SelectItem } from 'primeng/api';
import { Router } from '@angular/router';
import { VendorJob } from '../../../../services/nswag/nswagclient';

@Component({
  selector: 'app-vendor-job-common',
  
  standalone: false,
  templateUrl: './vendor-job-common.component.html',
  styleUrls: ['./vendor-job-common.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => VendorJobCommonComponent),
    multi: true
  }]
})
export class VendorJobCommonComponent implements OnInit, ControlValueAccessor, OnChanges {

  private _onTouched: () => void = () => {};

  @Input() _job: VendorJob = new VendorJob();
  get job() {
    return this._job;
  }
  set job(val: VendorJob) {
    this._job = val ?? new VendorJob();
    this.propagateChange(this._job);
  }
  @Input() supervisors: SelectItem[] = [];
  @Input() modelInvalid = false;
  @Input() disabled = false;
  @Input() showWorkbookLink = true;
  @Input() consumerJobId: string | null = null;
  @Input() securityToken = '';

  constructor(private _router: Router) { }

  ngOnInit() {
  }

  ngOnChanges() {
  }

  /****** ControlValueAccessor methods to handle ngModel read and updates ******/
  propagateChange = (_: any) => {};

  writeValue(obj: any): void {
    if (obj) {
      this._job = obj;
    }
  }

  registerOnChange(fn: any): void {
    this.propagateChange = fn;
  }

  registerOnTouched(fn: any): void {
    this._onTouched = fn;
  }

  setDisabledState?(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }

  /****** Componet UI control methods ******/
  navigateToWorkbook() {
    if (!this.job.id) {
      return;
    }
    if (this.job.useOldWorkbookInReadOnlyMode) {
      this._router.navigate(['/workbook/' + this.job.id]);
    } else if (this.consumerJobId) {
      this._router.navigate(['/workbook2/' + this.job.id + '/' + this.consumerJobId]);
    } else {
      this._router.navigate(['/workbook2/' + this.job.id]);
    }
  }

  downloadJobExport() {
    if (!this.job.id) {
      return;
    }
    window.open('/api/vendorjob/export/' + this.job.id + '?token=' + this.securityToken, '_blank');
  }

  downloadJobSummaryExport() {
    if (!this.job.id) {
      return;
    }
    window.open('/api/vendorjob/exportsummary/' + this.job.id + '?token=' + this.securityToken, '_blank');
  }
}
